<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    width="16"
    height="16"
    transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 16)"
    fill="transparent"
  />
  <path
    d="M7 13L3 8L7 3"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M13 13L9 8L13 3"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
